export default "__VITE_ASSET__455f68c2__"